import {
  MARKETPLACE_DETAILS_SUCCESS,
  MARKETPLACE_DETAILS_FAILS,
  SALES_CHANNEL_FILTER_DATA,
} from '../actions/marketPlaceAction';

const initialState = {
  marketPlaceData: null,
  salesChannel: null,
};

const marketPlaceReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case MARKETPLACE_DETAILS_SUCCESS:
      return { ...state, marketPlaceData: action.data };
    case MARKETPLACE_DETAILS_FAILS:
      return { error: action.error };
    case SALES_CHANNEL_FILTER_DATA:
      return { ...state, salesChannel: action.data }
    default:
      return state;
  }
};
export default marketPlaceReducer;
